/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
;(function (window, $, App, undefined_) {
  return (App.lessonPreview = {
    initialize() {
      if ($(".onLessonsPreviewView").length === 0) {
        return
      }
      return this.bindElements()
    },

    bindElements() {
      return $(document).on("click", ".customize-this-lesson", e => {
        return e.preventDefault()
      })
    },
  })
})(window, jQuery, window.App)
